<script>
    export let difficulty;
    let diffilcultycolor = difficulty;
    if(diffilcultycolor == 'Beginner') {
        diffilcultycolor = 'vec-bg-cut2dDesktop/50';
    } else if(diffilcultycolor == 'Intermediate') {
        diffilcultycolor = 'vec-bg-primary/50';
    } else if(diffilcultycolor == 'Advanced') {
        diffilcultycolor = 'vec-bg-aspire/50';
    } else {
        diffilcultycolor = 'vec-bg-primary/50';
    }
</script>

<style>p.diff {padding: 2px 5px !important;font-size: 0.75rem;margin-bottom: 10px;}</style>

<p class="{diffilcultycolor}  vec-p-2 vec-text-sm vec-rounded vec-inline-block">{difficulty}</p>
